import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1746d2c6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=1746d2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746d2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1746d2c6')) {
      api.createRecord('1746d2c6', component.options)
    } else {
      api.reload('1746d2c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1746d2c6&scoped=true&", function () {
      api.rerender('1746d2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bindingPhone/index.vue"
export default component.exports